import React from "react";

const AnalyticsPage = () => {
  return <div>AnalyticsPage</div>;
};

export default AnalyticsPage;
